import { useState, useEffect } from "react";
import { CiCircleRemove } from "react-icons/ci";
import ButtonLightTextIcon from "../../../components/ui/ButtonLightTextIcon";
import { API_URL } from "../../../utilities/constants";
import FullPageLoader from "../../../components/ui/FullPageLoader";

const Label = ({ title, required }) => (
  <p className="color-primary f-w-600" style={{ paddingBottom: "5px" }}>
    {title}
    {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
  </p>
);
const InfoItem = ({ icon, label, name, showfulltext = false, ...rest }) => {
  return (
    <div {...rest}>
      {!showfulltext ? (
        <div className="flex center-left" style={{ gap: "10px" }}>
          <div>{icon}</div>
          <div style={{ overflow: "hidden" }}>
            <p
              className="f-w-300"
              style={{
                color: "#aaaaaa",
                fontSize: "10px",
                lineHeight: 1,
                paddingBottom: "2px",
              }}
            >
              {label}
            </p>
            <p
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                paddingBottom: "2px",
                fontSize: "14px",
                wordBreak: "break-word",
              }}
            >
              {name}
            </p>
          </div>
        </div>
      ) : (
        <div
          style={{
            gap: "10px",
            width: "100%",
          }}
        >
          <div className="flex center-left" style={{ gap: "10px" }}>
            <div>{icon}</div>
            <div>
              <p
                className="f-w-300"
                style={{
                  color: "#aaaaaa",
                  fontSize: "10px",
                  lineHeight: 1,
                  paddingBottom: "2px",
                }}
              >
                {label}
              </p>
            </div>
          </div>
          <div style={{ overflow: "hidden" }}>
            <p
              style={{
                width: "400px",
                lineHeight: 1.2,
                borderRadius: "5px",
                marginLeft: "30px",
                "white-space": "pre-wrap",
                paddingRight: "30px",
                paddingBottom: "2px",
                fontSize: "14px",
                wordBreak: "break-word",
              }}
            >
              {name}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
const ViewTemplatePopUp = ({ setShow, id }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  useEffect(() => {
    fetchTemplate(id);
  }, [id]);

  const fetchTemplate = async (id) => {
    setLoading(true);
    try {
      const url = `${API_URL}/api/1.0.0/template/${id}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.result.responseCode === 200) {
          setData(data.data || null);
          setLoading(false);
        } else {
          setData(null);
          setLoading(false);
        }
      } else {
        setData(null);

        setLoading(false);
      }
    } catch (e) {
      console.error("Error fetching data", e);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="box" style={{ width: "580px", padding: "40px" }}>
      <FullPageLoader isActive={loading} />
      <div className="flex justifyContent-space-between">
        <h5 className="color-primary f-w-400">Push Notification Details</h5>
        <div style={{ marginLeft: "auto" }}>
          <CiCircleRemove
            className="cursor-pointer transition hover-color-secondary"
            onClick={() => setShow(false)}
            style={{
              fontSize: "32px",
            }}
          />
        </div>
      </div>
      <div
        style={{
          padding: "40px",
          height: "60vh",
          margin: "10px",
          overflowY: "scroll",
          padding: "20px 5px",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
      >
        {data && !loading && (
          <div className="activity-card pos-rel">
            <div
              style={{
                padding: "12px 0 12px 0 ",
              }}
            >
              <div
                className="info-row flex center-center"
                style={{
                  gap: "10px",
                  paddingBottom: "10px",
                }}
              >
                <InfoItem
                  className="col-1-1 info-row-column"
                  icon={
                    <svg
                      color="#2980B9"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    >
                      <path d="M18 20a6 6 0 0 0-12 0"></path>
                      <circle cx="12" cy="10" r="4"></circle>
                      <circle cx="12" cy="12" r="10"></circle>
                    </svg>
                  }
                  label="Name"
                  name={data?.name || "-"}
                />
              </div>
              <div
                className="info-row flex center-center"
                style={{
                  gap: "10px",
                  paddingBottom: "10px",
                }}
              >
                <InfoItem
                  className="col-1-1 info-row-column"
                  icon={
                    <svg
                      color="#2980B9"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    >
                      <path d="M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z"></path>
                      <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"></path>
                      <path d="M4 15v-3a6 6 0 0 1 6-6h0"></path>
                      <path d="M14 6h0a6 6 0 0 1 6 6v3"></path>
                    </svg>
                  }
                  label="Subject"
                  name={data?.subject || "NA"}
                />
              </div>
              <hr
                style={{
                  marginBottom: "12px",
                }}
              />
              <div
                className="info-row flex center-center"
                style={{
                  gap: "10px",
                  paddingBottom: "10px",
                }}
              >
                <InfoItem
                  className="col-1-1 info-row-column"
                  icon={
                    <svg
                      color="#2980B9"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    >
                      <rect x="3" y="3" width="7" height="7" rx="1"></rect>
                      <rect x="14" y="3" width="7" height="7" rx="1"></rect>
                      <rect x="3" y="14" width="7" height="7" rx="1"></rect>
                      <rect x="14" y="14" width="7" height="7" rx="1"></rect>
                    </svg>
                  }
                  showfulltext={true}
                  label="Body"
                  name={data?.body || "-"}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className="flex"
        style={{
          justifyContent: "space-between",
          gap: "12px",
          marginTop: "4px",
        }}
      >
        <ButtonLightTextIcon
          title="Cancel"
          onClick={() => setShow(false)}
          disabled={loading}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26.562"
              height="17.809"
              viewBox="0 0 26.562 17.809"
            >
              <path d="M0,8.88,10.686,0l1.937,2.293L6.453,7.4H26.562v3H6.454l6.166,5.108-1.934,2.3Z" />
            </svg>
          }
        />
      </div>
    </div>
  );
};

export default ViewTemplatePopUp;
